var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 2.91667H11.9C12.0933 2.91667 12.25 3.07337 12.25 3.26667V11.9C12.25 12.0933 12.0933 12.25 11.9 12.25H2.1C1.9067 12.25 1.75 12.0933 1.75 11.9V3.26667C1.75 3.07337 1.9067 2.91667 2.1 2.91667H4.375",
    stroke: "#26252C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49581 3.6931L9.61541 2.97551C9.62176 2.93741 9.62176 2.89853 9.61541 2.86043L9.49581 2.14284C9.40205 1.58028 8.91533 1.16797 8.34502 1.16797H5.65498C5.08467 1.16797 4.59795 1.58028 4.50419 2.14284L4.38459 2.86043C4.37824 2.89853 4.37824 2.93741 4.38459 2.97551L4.50419 3.6931C4.59795 4.25565 5.08467 4.66797 5.65498 4.66797H8.34502C8.91533 4.66797 9.40205 4.25565 9.49581 3.6931Z",
    stroke: "#26252C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08203 9.91797L9.91537 9.91797",
    stroke: "#26252C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.9c823965ede21e9e49fc0d9af9e9b196.svg";
export { ForwardRef as ReactComponent };